type Result = { passed: boolean; status?: string };

// Only retry an explicitly pending result, never failures, expiry or auth errors.
export async function queryReturnedFace(query: () => Promise<Result>, signal: AbortSignal, onPending: () => void): Promise<Result> {
  for (let attempt = 0; ; attempt++) {
    signal.throwIfAborted();
    const result = await query();
    signal.throwIfAborted();
    if (result.passed || result.status !== "pending" || attempt === 3) return result;
    onPending();
    await new Promise<void>((resolve, reject) => {
      const cancel = () => { clearTimeout(timer); reject(signal.reason); };
      const timer = setTimeout(() => { signal.removeEventListener("abort", cancel); resolve(); }, 6000);
      signal.addEventListener("abort", cancel, { once: true });
      if (signal.aborted) cancel();
    });
  }
}
